import { c as _c } from "react/compiler-runtime";
import { NavPanelContent } from '@/components/Organisms/Navigation/Menu/NavPanelContent';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import { breakpoints } from '@/styles/media';
import type { KeyboardEvent } from 'react';
import styled, { css } from 'styled-components';
export const NavigationPanel = () => {
  const $ = _c(10);
  const {
    navSections,
    hoverMenuOffset,
    visibleHoverMenuIndex,
    closeMenu
  } = useNavigationContext();
  if (!navSections || visibleHoverMenuIndex === null) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const section = navSections[visibleHoverMenuIndex];
  if (!section.columns || !section.columns.length) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== closeMenu) {
    t0 = event => {
      if (event.key === "Escape") {
        closeMenu();
      }
    };
    $[2] = closeMenu;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== hoverMenuOffset || $[5] !== section) {
    t1 = <MenuPosition><StyledNavPanelContent section={section} $offset={hoverMenuOffset} /></MenuPosition>;
    $[4] = hoverMenuOffset;
    $[5] = section;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t0 || $[8] !== t1) {
    t2 = <MenuOverlay onKeyDown={t0}>{t1}</MenuOverlay>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
const MenuPosition = styled.div`
    margin: 0 auto;
    display: block;
`;
const StyledNavPanelContent = styled(NavPanelContent)<{
  $offset: number;
}>`
    ${({
  $offset
}) => css`
        ${breakpoints.XXL`
           padding-left: calc(${$offset.toString()}px + var(--size-grid-unit));
        `}
    `};
`;
export const MenuOverlay = styled.div`
    font-size: var(--cds-font-body-default-fontsize);
    line-height: var(--cds-font-body-default-lineheight);
    letter-spacing: var(--cds-font-body-default-letterspacing);
    width: 100%;
    background-color: var(--cds-color-background);
    border-top: solid 1px var(--color-lines-subtleDivider);
    border-bottom: solid 1px var(--color-lines-subtleDivider);
    position: absolute;
    left: 0;
    color: var(--cds-color-text);
    z-index: var(--zIndex-navigationBar);
`;